import { render, staticRenderFns } from "./FunctionCalling.vue?vue&type=template&id=2b86ce6e"
import script from "./FunctionCalling.vue?vue&type=script&lang=js"
export * from "./FunctionCalling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports